module.exports = __webpack_public_path__ + "assets/202509252035/img/over15.7b27d0a6.png";